import axios from 'axios';
import { BASENAME } from '../constants/general';

let segment = '';
let breadcrumbs = '';

export const localLog = seg => {
	segment = seg;
	let obj = {
		prt_products_segment: segment
	};
	return recordEvent('PRT_FIND_PRODUCT', JSON.stringify(obj));
};

export const localDownloadLog = async trackingParameters => {
	let obj = {
		prt_products_segment: trackingParameters.segment,
		prt_datasheet_name: trackingParameters.partNumber,
		prt_datasheet_link: trackingParameters.redirectLink
	};

	return recordEvent(
		'PRT_DOWNLOAD_SHEET',
		JSON.stringify(obj),
		trackingParameters.partRankIndex,
		trackingParameters.opn
	);
};

export const localProductLog = async trackingParameters => {
	let obj = {
		prt_products_segment: trackingParameters.segment,
		prt_product_name: trackingParameters.partNumber
	};
	return recordEvent('PRT_VIEW_WPN', JSON.stringify(obj), trackingParameters.partRankIndex, trackingParameters.opn);
};

export const localView = () => {
	let obj = {
		page_title: 'PRT+ ' + segment,
		page_breadcrumbs: '/Design/Tools & Software/PRT+/' + breadcrumbs,
		page_section: 'Design',
		page_segment: 'Tools & Software'
	};

	return recordEvent('PRT_VIEW', JSON.stringify(obj));
};

export function recordEvent(name, data, partRankIndex, opn) {
	axios
		.post(BASENAME + '/api/trackEvent', { name: name, data: data, partRankIndex: partRankIndex, opn: opn })
		.then(response => {
			//
		})
		.catch(error => {
			console.error('recordEvent error', error);
		});
}
